export enum WorkflowSchedulingInstancesListSortProp {
	Id = 'Id',
	WorkflowDefinitionName = 'WorkflowDefinitionName',
	CreationDateTime = 'CreationDateTime',
	EndDateTime = 'EndDateTime',
}
